import { z } from "zod";

export const chartConfigurationYScaleType = z.enum(["logarithmic", "linear"]);
export type ChartConfigurationYScaleType = z.infer<typeof chartConfigurationYScaleType>;

export const chartConfigurationSchema = z.object({
    yAxis: z.object({
        scaleType: chartConfigurationYScaleType,
        min: z.number(),
        max: z.number(),
        stepSize: z.number().optional(),
    }),
});
export type ChartConfiguration = z.infer<typeof chartConfigurationSchema>;

export const userConfigurationSchema = z.object({
    chartConfigurations: z.record(z.string(), chartConfigurationSchema),
});
export type UserConfiguration = z.infer<typeof userConfigurationSchema>;
